module.exports = __webpack_public_path__ + "static/media/LOTR.2c38ebe1.jpg";